'use strict';
import angular from 'angular';

angular.module('creatives.services', [])

    .factory('creativesService', ['IORestangular', function(IORestangular) {
        var creatives = IORestangular.all('/creatives/libraryCreatives');
        var creativesForClient = IORestangular.all('/creatives/libraryCreativesForClient');
        var creative = IORestangular.all('/creatives/creative');
        var flight = IORestangular.all('/creatives/assignLibraryCreativeToFlight');
        var lineItem = IORestangular.all('/creatives/assignLibraryCreativeToLineItem');
        var order = IORestangular.all('/creatives/assignLibraryCreativeToOrder');
        var deleteCreative = IORestangular.all('/creatives/deleteCreativeFromLibrary');
        var sign = IORestangular.all('/creatives/imgSignature');
        var cloudinary = IORestangular.all('/creatives/addCloudinaryCreative');
        var fileTypes = IORestangular.all('form/fileTypes');

        var getAcceptableFileTypes = function(sectionVal) {
            return fileTypes.customGET(undefined, {section: sectionVal}, undefined, undefined);
        };

        var getCreatives = function(paramObj) {
            return creatives.customPOST(paramObj, undefined, undefined, undefined);
        };

        var getCreativesForClient = function(paramObj) {
            return creativesForClient.customGET(undefined, paramObj, undefined, undefined);
        };

        var getCreative = function(paramObj) {
            return creative.customGET(undefined, paramObj, undefined, undefined);
        }

        var assignToLineItem = function(obj) {
            return lineItem.customPOST(obj, undefined, undefined, undefined);
        }

        var assignToFlight = function(obj) {
            return flight.customPOST(obj, undefined, undefined, undefined);
        }

        var assignToOrder = function(obj) {
            return order.customPOST(obj, undefined, undefined, undefined);
        }

        var deleteCreativeLibrary = function(obj) {
            return deleteCreative.customDELETE(undefined, obj, undefined, undefined);
        }

        var getImgSignature = function(paramObj) {
            return sign.customGET(undefined, paramObj, undefined, undefined);
        };

        var addCloudinaryCreative = function(obj) {
            return cloudinary.customPOST(obj, undefined, undefined, undefined);
        }

        return {
            getAcceptableFileTypes: getAcceptableFileTypes,
            getCreatives: getCreatives,
            getCreativesForClient: getCreativesForClient,
            getCreative: getCreative,
            assignToLineItem: assignToLineItem,
            assignToFlight: assignToFlight,
            assignToOrder: assignToOrder,
            deleteCreativeLibrary: deleteCreativeLibrary,
            getImgSignature: getImgSignature,
            addCloudinaryCreative: addCloudinaryCreative
        }
    }])
    .service('CreativeServicePro', CreativeServicePro)
    .service('CreativeFactory', CreativeFactory);

function CreativeServicePro(CreativeFactory, $q) {
    let service = {};

    // Get all products for a cluster
    service.getImgSignature = function (params) {
        let deferred = $q.defer();
        CreativeFactory.getImgSignature().get(params).$promise.then(function (data) {
            deferred.resolve(data);
        }, function (response) {
            console.log(response);
            deferred.reject(response);
        });

        return deferred.promise;
    };

    return service;
}

CreativeFactory.$inject = ['$resource', 'AppConfig'];

function CreativeFactory($resource, AppConfig) {

    let factory = {};

    factory.getImgSignature = function() {
        return $resource(AppConfig.IO_API_URL + 'creatives/imgSignature', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    return factory;

}